export default "__VITE_ASSET__c6f1926e__"